import React from 'react';

import { Progress as AProgress, ProgressProps } from 'antd';

export interface IProgressParams extends ProgressProps {}

export const Progress = ({ ...rest }: IProgressParams) => <AProgress {...rest} />;
